import { LocationService } from './../shared/services/location.service';
import {
	Component,
	OnInit,
	ViewEncapsulation,
	OnDestroy,
	Input,
	ContentChildren,
	AfterContentInit,
	ViewChild,
	ElementRef,
	QueryList,
	AfterViewChecked,
	Output,
	EventEmitter,
	AfterViewInit,
	ChangeDetectionStrategy
} from "@angular/core";
import { IdService } from "../shared/services/id.service";
import {Location} from '@angular/common';

import { TabContentComponent } from "./tab-content/tab-content.component";
import { ActivatedRouteSnapshot, NavigationEnd, Router } from "@angular/router";
import { trigger, transition, style, animate } from "@angular/animations";

@Component({
	selector: "rbc-tab",
	templateUrl: "./tab.component.html",
	styleUrls: ["./tab.component.scss"],
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger("opacity-left", [
			transition(":enter", [
				style({ opacity: 0, transform: "translateX(-1.5rem)" }),
				animate("0.2s", style({ opacity: 1, transform: "translateX(0)" }))
			]),
			transition(":leave", [
				animate("0.2s", style({ opacity: 0, transform: "translateX(-1.5rem)" }))
			])
		]),
		trigger("opacity-right", [
			transition(":enter", [
				style({ opacity: 0, transform: "translateX(1.5rem)" }),
				animate("0.2s", style({ opacity: 1, transform: "translateX(0)" }))
			]),
			transition(":leave", [
				animate("0.2s", style({ opacity: 0, transform: "translateX(1.5rem)" }))
			])
		]),
		// trigger("opacity-left", [
		// 	state("true", style({
		// 		overflow: "hidden",
		// 		transform: "translateX(1.5rem)",
		// 		opacity: 1
		// 	})),
		// 	state("false", style({
		// 		overflow: "hidden",
		// 		transform: "translateX(-1.5rem)",
		// 		opacity: 0
		// 	})),
		// 	transition("true => false", animate("400ms ease-out")),
		// 	transition("false => true", animate("400ms ease-in"))
		// ]),
		// trigger("opacity-right", [
		// 	state("true", style({
		// 		overflow: "hidden",
		// 		transform: "translateX(-1.5rem)",
		// 		opacity: 1
		// 	})),
		// 	state("false", style({
		// 		transform: "translateX(1.5rem)",
		// 		overflow: "hidden",
		// 		opacity: 0
		// 	})),
		// 	transition("true => false", animate("400ms ease-out")),
		// 	transition("false => true", animate("400ms ease-in"))
		// ]),

		trigger("opacity", [
			transition(":enter", [
				style({ opacity: 0,  transform:"translateX(-100%)"}),
				animate("550ms ease-in", style({ opacity: 1,  transform:"translateX(0%)"}))
			]),
			transition(":leave", [
				style({ position: "absolute",  top: "0", left:"0", width:"100%", transform:"translateX(0%)"}),
				animate("550ms", style({ opacity: 0, transform:"translateX(-10%)"}))
			]),
		]),

	]
})
export class TabComponent implements OnInit, OnDestroy, AfterContentInit, AfterViewChecked, AfterViewInit {
	// Input Parameters
	@Input() id: string;
	@Input() default: number | string;
	@Input() disabled = false;
	@Input() scrollable = false;
	@Input() scrollColor: string;
	@Input() size: string;
	@Input() transition = false;
	@Input() flush: boolean;
	@Input() showAll: boolean;
	@Input() showAllLabel = "Show all";
	@Input() showAllFirst: boolean;
	@Input() router = false;

	_current;
	@Input() set current(val){
		this._current = val;
	};

	get current(){
		return this._current;
	}
	@Input() arrowLeftLabel = "Move left";
	@Input() arrowRightLabel = "Move right";

	@ContentChildren(TabContentComponent) tabs: QueryList<TabContentComponent>;
	@ViewChild("tabList", { static: false }) tabList: ElementRef;
	@ViewChild("tabWrap", { static: false }) tabWrap: ElementRef;

	@Output() tabupdate = new EventEmitter<{ active: number | string; id: string }>();

	direction = "right";
	scrollDisabledLeft = true;
	scrollDisabledRight = false;
	isScrollable = false;
	contentTransitionState = true;
	nextActiveTab: TabContentComponent;
	nextActiveIndex: number;
	lastActiveIndex: number;
	content = true;
	urlService;


	constructor(private idService: IdService, private routerService: Router, private location: LocationService) {}

	ngOnInit() {
		this.id = this.id ? this.id : this.idService.generate();
		if(this.router){
			this.urlService = this.location.urlChanged.subscribe(e => {
				this.current = e["url"];
				this.setCurrentProgrammatically(true);
			});
		}
	}

	ngAfterContentInit() {
		this.setCurrentProgrammatically();
	}

	ngOnChanges(){
		this.setCurrentProgrammatically();
	}
	ngAfterViewInit() {
		this.content = this.tabList.nativeElement.childNodes.length > 1;
	}

	ngAfterViewChecked() {
		this.determineIfScrollable();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
		if(this.router){
			this.urlService.unsubscribe();
		}
	}


	setCurrentProgrammatically(sub?){
		const defaultTabIndex = this.default || 0;
		const _self = this;

		if (this.tabs && this.tabs.length) {
			// check if current tab has been provided
			if (_self.current && _self.current !== "all") {
				const activeTab = _self.tabs.filter(tab => ( this.router ? tab.routerTo === this.current : tab.id === this.current))[0] || _self.tabs.first;
				activeTab["isActive"] = true;
				_self.preSwitchTab(activeTab, null, sub);
				// if not, then switch active tab to first tab
			} else {
				// set the active tab to the first tab that is not disabled
				const activeTab = _self.tabs.filter(tab => ( this.router ? tab.routerTo === this.routerService.url : !tab.disabled))[0];

				if (activeTab) {
					activeTab["isActive"] = true;
					_self.preSwitchTab(activeTab, null, sub);
				}
			}
		}
	}

	determineIfScrollable() {
		// even if scrollable is off, tabs should be accessible on small viewports through scrollability
		if (this.tabList && this.tabWrap) {
			this.isScrollable = !(
				(this.tabList.nativeElement as HTMLElement).scrollWidth <=
				(this.tabWrap.nativeElement as HTMLElement).offsetWidth
			);
		}
	}

	get contentClassGen() {
		let classes = {};
		classes["rbc-tab-" + this.direction] = this.transition;
		classes["rbc-tab-transition-quick"] = this.showAll;
		classes["rbc-tab-show-all"] = this.showAll;

		return classes;
	}

	calculateClasses() {
		let classes = {};
		classes["rbc-tab-disabled"] = this.disabled;
		classes["rbc-tab-scrollable"] = this.isScrollable;
		classes["rbc-tab-" + this.size] = this.size;
		classes["rbc-tab-flush"] = this.flush;

		return classes;
	}

	getBgColor(direction = "left") {
		let value;
		value =
			direction === "left" && this.scrollColor
				? `linear-gradient(to left, rgba(${this.scrollColor}, 0) 0%, rgba(${this.scrollColor}, 1) 40%)`
				: `linear-gradient(to left, rgba(${this.scrollColor}, 1) 60%, rgba(${this.scrollColor}, 0) 100%)`;

		return { "background-image": value };
	}

	toggleContentTransition() {
		this.contentTransitionState = !this.contentTransitionState;
	}

	// content animation direction
	determineNextActiveDirection(lastActiveIndex: number, nextActiveIndex: number): "right" | "left" {
		return nextActiveIndex > lastActiveIndex ? "right" : "left";
	}
	determineLastActiveDirection(lastActiveIndex: number, nextActiveIndex: number): "right" | "left" {
		return lastActiveIndex > nextActiveIndex ? "right" : "left";
	}

	preSwitchTab(tab: TabContentComponent, event = null, sub = false) {
		this.nextActiveTab = tab; // save for later
		const tabs = this.tabs.toArray();
		if (!this.disabled && !tab.disabled) {
			this.nextActiveIndex = tabs.indexOf(tab);
			tabs.forEach((tabItem, i) => {
				if (tabItem.isActive) {
					this.lastActiveIndex = i;
				}

				if (this.transition) {
					// make sure item has transition enabled
					tabItem.hasTransition = true;
					// start transition out of the previous tab
					this.direction = this.determineLastActiveDirection(i, this.nextActiveIndex);
					this.toggleContentTransition();
				} else if (!this.transition) {
					// make sure item has transition disabled
					tabItem.hasTransition = false;
				}

				// turn off the rest
				tabItem.isActive = false;
			});

			// if transition is disabled, no need to wait
			if (!this.transition) {
				if(this.router){
					this.nextActiveTab.isActive = true;
					this.tabupdate.emit({ active: this.nextActiveTab.name, id: this.nextActiveTab.id });
					this.current = tab.routerTo
					if(!sub){
						this.routerService.navigateByUrl(tab.routerTo)
					}
				}else{
					this.nextActiveTab.isActive = true;
					this.tabupdate.emit({ active: this.nextActiveTab.name, id: this.nextActiveTab.id });
					this.current = this.nextActiveTab.id
				}

				delete this.nextActiveTab;
				delete this.nextActiveIndex;
				delete this.lastActiveIndex;
			}
			// if tab switch was triggered by click, make sure tab links are not being cut off
			if (event && this.isScrollable) {
				this.scrollLink(event.target);
			}
		}
	}

	onTransitionEvent(e) {
		switch (e.type) {
			case "leave-complete": {
				if (
					this.lastActiveIndex != null &&
					this.nextActiveIndex != null
				) {
					this.direction = this.determineNextActiveDirection(
						this.lastActiveIndex,
						this.nextActiveIndex
					);
					this.toggleContentTransition();
					delete this.lastActiveIndex;
					delete this.nextActiveIndex;
				}
				break;
			}
			case "enter": {
				if (this.nextActiveTab) {
					this.nextActiveTab.isActive = true;
				}
				break;
			}
			case "enter-complete": {
				this.tabupdate.emit({
					active: this.nextActiveTab.name,
					id: this.nextActiveTab.id
				});
				delete this.nextActiveTab;
				break;
			}
		}
	}

	scrollTabs(dir) {
		const tabWrapWidth = this.tabWrap.nativeElement.offsetWidth;
		const start = this.tabWrap.nativeElement.scrollLeft;
		const distance = tabWrapWidth * 0.75;

		let step = tabWrapWidth / 15;
		step = dir === "right" ? step : -step;

		this.scrollTo(this.tabWrap.nativeElement, step, dir, start, distance);
	}

	scrollLink(el) {
		const linkBox = el.getBoundingClientRect();
		const tabBox = this.tabWrap.nativeElement.getBoundingClientRect();
		const tabWrapBox = this.tabWrap.nativeElement.getBoundingClientRect();
		const arrowWidth = 35;
		const start = this.tabWrap.nativeElement.scrollLeft;

		// check if selected tab link is too far to the left
		if (!this.scrollDisabledLeft && linkBox.x < tabBox.x + arrowWidth) {
			const distance = tabBox.x - linkBox.x + arrowWidth;
			this.scrollTo(
				this.tabWrap.nativeElement,
				-10,
				"left",
				start,
				distance
			);

			// check if selected tab link is too far to the right
		} else if (
			!this.scrollDisabledRight &&
			linkBox.x + linkBox.width >
			tabWrapBox.x + tabWrapBox.width - arrowWidth
		) {
			const distance =
				linkBox.x +
				linkBox.width -
				(tabWrapBox.x + tabWrapBox.width) +
				arrowWidth;
			this.scrollTo(
				this.tabWrap.nativeElement,
				10,
				"right",
				start,
				distance
			);
		}
	}

	scrollTo(el, step, dir = "right", start, dist) {
		const scrollWidth = this.tabWrap.nativeElement.firstChild.scrollWidth;
		const elWidth = el.offsetWidth;
		const scrollPos = el.scrollLeft;

		// add step to current scroll positon to animate
		el.scrollLeft = scrollPos + step;

		// create next animation step
		const animationFrameFn = this.scrollTo.bind(this, ...arguments);
		// check if scroll position has reached its end value or the end of the wrapper element
		if (
			dir === "right" &&
			scrollPos <= start + dist &&
			scrollPos + elWidth < scrollWidth
		) {
			requestAnimationFrame(animationFrameFn);
			// check if scroll position has reached its end value or the beginning of the wrapper element
		} else if (
			dir === "left" &&
			scrollPos >= start - dist &&
			scrollPos > 0
		) {
			requestAnimationFrame(animationFrameFn);
		}
	}

	updateArrows() {
		// get widths and current scroll position
		const tabWrapWidth = Math.round(
			this.tabWrap.nativeElement.getBoundingClientRect().width
		);
		const scrollPos = this.tabWrap.nativeElement.scrollLeft;

		// disable left tab if scroll position is at 0
		this.scrollDisabledLeft = scrollPos <= 0;
		// disable right tab if scroll position is at end of scroll bar width
		this.scrollDisabledRight =
			scrollPos + tabWrapWidth >= this.tabWrap.nativeElement.scrollWidth;
	}
}
